import moment from 'moment'
import React from 'react'
import history from 'routes/history'
import { path } from 'ramda'

const ProjectResultsListItem = props => (
  <div className="list-item-container pointer" onClick={() => history.push(props.listItemUrl)}>
    <div className="list-item-image">
      <div className="incrowd-logo" />
      <div className="triangle-bottomleft" />
      <i className="im-play" />
    </div>
    <div className="list-item-details">
      <div className="list-item-research-repo-user-details">
        <p className="list-item-username"><span>{`${props.userId}`}</span>{` - ${props.crowd}`}</p>
        <p className="list-item-date">{moment(props.interviewDate).locale('en').format('MMMM Do YYYY, h:mma')}</p>
      </div>
      <div className="list-item-icons">
        <i className="im-play" />
        <p>Recording</p>
      </div>
      {props.transcriptsRequested && <div className={`list-item-icons ${path([0, 'transcriptUrl'], props.deliverableUrls) ? '' : 'processing'}`}>
        <i className="im-barshor" />
        <p>{path([0, 'transcriptUrl'], props.deliverableUrls) ? 'Transcript' : 'Processing'}</p>
      </div>}
    </div>
  </div>
)

export default ProjectResultsListItem
